/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCouponHistoryUpdateReqVo
 */
export interface UserCouponHistoryUpdateReqVo {
    /**
     * 用户的优惠券 ID，关联用户优惠券表主键，必传
     * @type {number}
     * @memberof UserCouponHistoryUpdateReqVo
     */
    userCouponId: number;
    /**
     * 本次操作的优惠券数量，必须大于 0，必传
     * @type {number}
     * @memberof UserCouponHistoryUpdateReqVo
     */
    number: number;
    /**
     * 操作前的优惠券余额数量，必传
     * @type {number}
     * @memberof UserCouponHistoryUpdateReqVo
     */
    principal: number;
    /**
     * 备注说明，记录操作原因或说明信息，可选
     * @type {string}
     * @memberof UserCouponHistoryUpdateReqVo
     */
    remark?: string;
    /**
     * 用户 ID，关联用户表主键，必传
     * @type {number}
     * @memberof UserCouponHistoryUpdateReqVo
     */
    userId: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof UserCouponHistoryUpdateReqVo
     */
    enable: number;
    /**
     * 优惠券进出类型：0-出优惠券（扣减），1-进优惠券（增加），必传
     * @type {number}
     * @memberof UserCouponHistoryUpdateReqVo
     */
    intOutType: number;
}

/**
 * Check if a given object implements the UserCouponHistoryUpdateReqVo interface.
 */
export function instanceOfUserCouponHistoryUpdateReqVo(value: object): value is UserCouponHistoryUpdateReqVo {
    if (!('userCouponId' in value) || value['userCouponId'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('principal' in value) || value['principal'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('intOutType' in value) || value['intOutType'] === undefined) return false;
    return true;
}

export function UserCouponHistoryUpdateReqVoFromJSON(json: any): UserCouponHistoryUpdateReqVo {
    return UserCouponHistoryUpdateReqVoFromJSONTyped(json, false);
}

export function UserCouponHistoryUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCouponHistoryUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userCouponId': json['userCouponId'],
        'number': json['number'],
        'principal': json['principal'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'userId': json['userId'],
        'enable': json['enable'],
        'intOutType': json['intOutType'],
    };
}

export function UserCouponHistoryUpdateReqVoToJSON(json: any): UserCouponHistoryUpdateReqVo {
    return UserCouponHistoryUpdateReqVoToJSONTyped(json, false);
}

export function UserCouponHistoryUpdateReqVoToJSONTyped(value?: UserCouponHistoryUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userCouponId': value['userCouponId'],
        'number': value['number'],
        'principal': value['principal'],
        'remark': value['remark'],
        'userId': value['userId'],
        'enable': value['enable'],
        'intOutType': value['intOutType'],
    };
}

